import InstrumentInstanceScheduleModel from "@/models/lab/InstrumentInstanceScheduleModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class InstrumentInstanceScheduleCollection extends LabServiceCollection {
  model() {
    return InstrumentInstanceScheduleModel;
  }

  prepareFilter(CollectionFilter) {
    //CollectionFilter.sortAddDesc('order');
    return CollectionFilter;
  }

}
